import { loadHeroVideo } from '../utils/video';
import { faqAccordion } from '../utils/faq';
import { screenshotsAccordion } from '../utils/screenshots';
import { triggerHighlightAnimations } from '../utils/animations';

document.addEventListener('DOMContentLoaded', function (e) {
  loadHeroVideo();
  faqAccordion();
  screenshotsAccordion();
  triggerHighlightAnimations();
});
